import { ArrowRight, Phone } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { business } from '../../content/site';

export function HeroActions({ inverse = false }) {
  return (
    <div className={`hero-actions${inverse ? ' hero-actions--inverse' : ''}`}>
      <Link className="button button--primary" to="/contact">
        Request an Estimate
        <ArrowRight aria-hidden="true" size={18} weight="bold" />
      </Link>
      <a className="button button--secondary" href={business.phoneHref}>
        <Phone aria-hidden="true" size={18} weight="fill" />
        {business.phoneDisplay}
      </a>
    </div>
  );
}

